import React, { Component } from "react";
import WidgetPageRenderer from "../widgets/WidgetPageRenderer";

import LoadingOverlay from "./LoadingOverlay";
export default class Widgetslibrary_NEW extends Component {
  render() {
    return <WidgetPageRenderer pageRoute="widgetslibrary" />;
  }
}
